import React from "react";
import { animateScroll as scroll } from "react-scroll";
import { FaLinkedin } from "react-icons/fa";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  FooterCtaBlock,
  FooterCtaLabel,
  FooterCtaButton,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  Logo,
} from "./FooterElements";
import ShiftITLogo from "../../images/ShiftITLogo.png";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <FooterCtaBlock>
          <FooterCtaLabel>Get started now!</FooterCtaLabel>
          <FooterCtaButton
            href="https://outlook.office.com/bookwithme/user/bb51bbe3bc3d4e3eb0635e8990c6ad0b@shift-it.io?anonymous&ep=plink"
            aria-label="Book a 15-minute Fit Check"
            target="_blank"
            rel="noreferrer"
          >
            Book a 15-minute Fit Check
          </FooterCtaButton>
        </FooterCtaBlock>

        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>Company</FooterLinkTitle>
              <FooterLink href="/#about" aria-label="About Shift IT">
                About
              </FooterLink>
              <FooterLink href="/contact" aria-label="Contact Sean at Shift IT">
                Contact
              </FooterLink>
            </FooterLinkItems>

            <FooterLinkItems>
              <FooterLinkTitle>Legal</FooterLinkTitle>
              <FooterLink href="/privacy" aria-label="Privacy Policy">
                Privacy
              </FooterLink>
              <FooterLink href="/terms" aria-label="Terms of Service">
                Terms
              </FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/" onClick={toggleHome}>
              <Logo src={ShiftITLogo} alt="Shift IT Logo" />
            </SocialLogo>
            <WebsiteRights>
              Shift IT LLC © {new Date().getFullYear()} · Atlanta, GA ·{" "}
              <a
                href="tel:+14047792188"
                style={{ color: "#ffcb66", textDecoration: "none" }}
                aria-label="Call Shift IT at (404) 779-2188"
              >
                (404) 779-2188
              </a>
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink
                href="//www.linkedin.com/company/shift-it-io"
                target="_blank"
                aria-label="Linkedin"
              >
                <FaLinkedin />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
